/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import routes from "routes.js";

import logo from "assets/img/MaeCoreDark.png";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";

var ps;

function Admin(props) {
  const location = useLocation();
  const mainPanelRef = React.useRef(null);
  const [sidebarOpened, setsidebarOpened] = React.useState(
    document.documentElement.className.indexOf("nav-open") !== -1
  );
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanelRef.current, {
        suppressScrollX: true,
      });
      // Las tablas ahora manejan su propio PerfectScrollbar en el componente DataTable
      // No inicializamos PerfectScrollbar aquí para evitar conflictos
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        if (ps) {
          ps.destroy();
        }
        document.documentElement.classList.add("perfect-scrollbar-off");
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    // Solo resetear scroll, las tablas manejan su propio PerfectScrollbar
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setsidebarOpened(!sidebarOpened);
  };
  const getRoutes = (routes) => {
    const routeElements = [];

    routes.forEach((prop, key) => {
      if (prop.redirect) return;

      // Handle collapsible routes with views
      if (prop.collapse && prop.views) {
        prop.views.forEach((view, viewKey) => {
          if (view.layout === "/admin" && view.path) {
            routeElements.push(
              <Route
                path={view.path}
                element={view.component}
                key={`${key}-${viewKey}`}
              />
            );
          }
        });
      }
      // Handle regular routes
      else if (prop.layout === "/admin" && prop.path) {
        routeElements.push(
          <Route
            path={prop.path}
            element={prop.component}
            key={key}
          />
        );
      }
    });

    return routeElements;
  };
  const getBrandText = (path) => {
    // Primero buscar en rutas colapsables (que tienen views)
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && routes[i].views) {
        for (let j = 0; j < routes[i].views.length; j++) {
          const view = routes[i].views[j];
          if (view.layout === "/admin" && view.path) {
            const fullPath = view.layout + view.path;
            if (location.pathname === fullPath || location.pathname.startsWith(fullPath + "/")) {
              return view.name;
            }
          }
        }
      }
    }
    
    // Luego buscar en rutas regulares
    for (let i = 0; i < routes.length; i++) {
      if (!routes[i].collapse && routes[i].layout === "/admin" && routes[i].path) {
        const fullPath = routes[i].layout + routes[i].path;
        if (location.pathname === fullPath || location.pathname.startsWith(fullPath + "/")) {
          return routes[i].name;
        }
      }
    }
    
    // Si no se encuentra ninguna coincidencia, retornar "MaeCore" en lugar de "Brand"
    return "MaeCore";
  };
  return (
    <BackgroundColorContext.Consumer>
      {({ color, changeColor }) => (
        <React.Fragment>
          <div className="wrapper">
            <Sidebar
              routes={routes}
              logo={{
                innerLink: "/admin/dashboard",
                text: "MaeCore",
                imgSrc: logo,
              }}
              toggleSidebar={toggleSidebar}
            />
            <div className="main-panel" ref={mainPanelRef} data={color}>
              <AdminNavbar
                brandText={getBrandText(location.pathname)}
                toggleSidebar={toggleSidebar}
                sidebarOpened={sidebarOpened}
              />
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboard" replace />}
                />
              </Routes>
              {
                // we don't want the Footer to be rendered on map page
                location.pathname === "/admin/maps" ? null : <Footer fluid />
              }
            </div>
          </div>
          <FixedPlugin bgColor={color} handleBgClick={changeColor} />
        </React.Fragment>
      )}
    </BackgroundColorContext.Consumer>
  );
}

export default Admin;
